import '../../../css/components/pages/password-set-up.css';
import { Loc } from 'main.core';
import { Ajax } from '../../api/ajax';
import { mapState } from 'ui.vue3.pinia';
import { useLoggingInStore } from '../../pinia/store';
import {
	PasswordEditForm,
} from 'b24network.vue.base-components';
import {
	UserRedirect,
	UserAccount,
} from 'b24network.vue.cross-scenario-shared-js';

export const PasswordSetUp = {
	name: 'PasswordSetUp',

	components: {
		PasswordEditForm,
	},

	data(): Object
	{
		return {
			password: '',
			passwordError: '',
			isPasswordOk: false,
			isProcessingPasswordEnter: false,
		};
	},

	computed: {
		...mapState(useLoggingInStore, [
			'userCheckWord',
			'passwordSetUpUserDetails',
		]),

		userAccount(): Object
		{
			return {
				fullName: '',
				avatarUrl: '',
				socialServiceType: '',
				id: this.passwordSetUpUserDetails.id,
				login: this.passwordSetUpUserDetails.login,
			};
		},
	},

	mounted(): void
	{
		if (!this.passwordSetUpUserDetails.hasPassword)
		{
			return;
		}

		if (!this.passwordSetUpUserDetails)
		{
			UserRedirect.redirectToAuthorization();
		}

		document.title = Loc.getMessage('EXT_B24NET_LOGGING_IN_THINK_UP_PASSWORD');
	},

	methods: {
		onPasswordReady(isReady): void
		{
			this.isPasswordOk = isReady;
		},

		onPasswordChange(newPassword): void
		{
			this.password = newPassword;
		},

		async onPasswordEditContinueClick(): void
		{
			if (!this.password || !this.isPasswordOk)
			{
				return;
			}

			this.isProcessingPasswordEnter = true;

			try
			{
				await Ajax.changePassword(
					this.passwordSetUpUserDetails.login,
					this.password,
					this.userCheckWord,
				);
				UserRedirect.redirectToPortalsAfterPasswordSetUp();
			}
			catch (errorResponse)
			{
				this.updatePasswordErrorIfAny(errorResponse);
			}
			finally
			{
				this.isProcessingPasswordEnter = false;
			}
		},

		updatePasswordErrorIfAny(errorResponse): void
		{
			if (!errorResponse.errors?.length)
			{
				return;
			}

			const passwordError = (errorResponse.errors ?? [])
				.find((err) => err.code !== 'ERROR_CAPTCHA')
				?.message ?? ''
			;

			if (passwordError)
			{
				// For some historical reason backend appends <br> to error messages
				this.passwordError = passwordError.replace('<br>', '') ?? '';
			}
		},
	},

	template: `
		<div class="b24net-password-set-up b24net-island">
			<h2 class="b24net-password-set-up__title">
				${Loc.getMessage('EXT_B24NET_LOGGING_IN_THINK_UP_PASSWORD')}
			</h2>

			<PasswordEditForm
				continue-button-text="${Loc.getMessage('EXT_B24NET_LOGGING_IN_SAVE_AND_ENTER')}"
				:password-value="password"
				:user-account="userAccount"
				:show-password-repeat="false"
				:password-error="passwordError"
				:is-waiting="isProcessingPasswordEnter"
				:is-continue-disabled="isPasswordOk === false"
				@password-ready="onPasswordReady"
				@password-change="onPasswordChange"
				@continue-click="onPasswordEditContinueClick"
			/>
		</div>
	`,
};
